import { Button } from "antd";
import { AuthCheck, AUTH_ACTIONS } from "authorization";
import { RECORD_STATE } from "Constants";
import { RULES } from "Constants/rules";
import { useStoreState } from "easy-peasy";
import { isElement } from "lodash";
import React from "react";

export default function AddPaymentButton({ record, onClick, ...props }) {
  const { abilities } = useStoreState((store) => store.auth);
  const IsEnabled =
    record?.state === RECORD_STATE.ACTIVE &&
    record?.contractStatu === "ACTIVE" &&
    record?.type?.rule?.code !== RULES.RULE0001 &&
    AuthCheck(abilities, AUTH_ACTIONS.WRITE, "Sözleşmeler");
  return (
    <Button key="2" disabled={!IsEnabled} onClick={() => onClick && onClick()}>
      Tahsilat Ekle
    </Button>
  );
}
